import React, { useState, useEffect, useMemo } from "react";
import {
  Card, Input, Radio, Button, Form,
  Row, Col,
  Cascader,
  Modal,
  Select,
  Typography,
  Checkbox,
} from "antd";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmlToPdfmake from "html-to-pdfmake";
import companyLogo from '../assets/images/company_logo.png';
import parse from 'html-react-parser';
import "../assets/styles/app.css"

import dotenv from 'dotenv';
dotenv.config();

// read .env file
const { REACT_APP_SUPABASE_URL } = process.env;
const { REACT_APP_SUPABASE_KEY } = process.env;
const { REACT_APP_CURRENCY_API_KEY } = process.env;

const { Option } = Select;


pdfMake.vfs = pdfFonts.pdfMake.vfs;

// node build-vfs.js "examples/fonts"

pdfMake.fonts = {
  montserrat: {
    normal: "Montserrat-Regular.ttf",
    bold: "Montserrat-Regular.ttf",
    italics: "Montserrat-Regular.ttf",
    bolditalics: "Montserrat-Regular.ttf",
  },
  TimesNewRoman: {
    normal: "TimesNewRoman.ttf",
    bold: "TimesNewRoman-Bold.ttf",
    italics: "TimesNewRoman-Italic.ttf",
    bolditalics: "TimesNewRoman-BoldItalic.ttf",
  },
};




function Home() {
  const [cityData, setCityData] = useState([]);
  const [cascaderOptions, setCascaderOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [baseFiyat, setBaseFiyat] = useState(0);
  const [depremSeviye, setDepremSeviye] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [checked, setChecked] = useState(false);


  useEffect(() => {
    const fetchCityData = async () => {
      try {
        const response = await fetch(`${REACT_APP_SUPABASE_URL}/rest/v1/il_ilce_list`, {
          method: "GET",
          headers: {
            apikey: REACT_APP_SUPABASE_KEY,
          }
        });
        const data = await response.json();
        setCityData(data);
      } catch (error) {
        console.error("Error loading city data:", error);
      }
    };

    fetchCityData();
  }, []);

  useEffect(() => {
    if (cityData.length > 0) {
      const options = cityData.reduce((result, item) => {
        let city = result.find(city => city.value === item.il);
        if (!city) {
          city = {
            value: item.il,
            label: item.il,
            children: []
          };
          result.push(city);
        }
        city.children.push({
          value: item.ilce,
          label: item.ilce
        });
        return result;
      }, []);
      setCascaderOptions(options);
    }
  }, [cityData]);


  const [q1, setQ1] = useState(null);
  const [q2, setQ2] = useState(null);
  const [q3, setQ3] = useState(2);
  const [q4, setQ4] = useState("ZA");
  const [q5, setQ5] = useState(null);
  const [q6, setQ6] = useState(null);
  const [userName, setUserName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [totalIzolator, setTotalIzolator] = useState(0);
  const [totalIzolatorMaliyet, setTotalIzolatorMaliyet] = useState(0);
  const [totalStatikMaliyet, setTotalStatikMaliyet] = useState(0);
  const [tcmbEuro, setTcmbEuro] = useState(0);
  const [projeSuresi, setProjeSuresi] = useState({ min: 0, max: 0 });
  const [izolatorUretimSuresi, setIzolatorUretimSuresi] = useState({ min: 0, max: 0 });
  const [ToplamBedelEuro1, setToplamBedelEuro1] = useState(0);
  const [ToplamBedelEuro2, setToplamBedelEuro2] = useState(0);
  const [ToplamBedelEuro3, setToplamBedelEuro3] = useState(0);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const totalStatikMaliyetRaw = useMemo(() => Math.ceil(((q5 * 100) / tcmbEuro)), [q5, tcmbEuro]);
  const totalIzolatorRaw = useMemo(() => Math.ceil(q6 / 15), [q6]);
  const totalIzolatorMaliyetRaw = useMemo(() => Math.ceil(totalIzolatorRaw * baseFiyat), [totalIzolatorRaw, baseFiyat]);
  const toplamBedelEuro1Raw = useMemo(() => Math.ceil((totalIzolatorMaliyetRaw + totalStatikMaliyetRaw)), [totalIzolatorMaliyetRaw, totalStatikMaliyetRaw]);
  const toplamBedelEuro2Raw = useMemo(() => Math.ceil((toplamBedelEuro1Raw + 30000) / 10000) * 10000, [toplamBedelEuro1Raw]);
  const toplamBedelEuro3Raw = useMemo(() => Math.ceil(((toplamBedelEuro2Raw * 0.8) / 10000)) * 10000, [toplamBedelEuro2Raw]);
  const projeSuresiRaw = useMemo(() => calculateProjeSuresi(q5), [q5]);
  const izolatorUretimSuresiRaw = useMemo(() => calculateIzolatorUretimSuresi(totalIzolatorRaw), [totalIzolatorRaw]);

  // EURO Kuru
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://api.freecurrencyapi.com/v1/latest?apikey=${REACT_APP_CURRENCY_API_KEY}&currencies=TRY&base_currency=EUR`
        );
        const htmlContent = await response.json();
        const currency = parseFloat(htmlContent.data.TRY);
        if (currency > 0) {
          setTcmbEuro(currency);
          // console.log("Fetched Correctly:", currency);
        } else {
          // console.log("Error fetching data:", htmlContent);
        }
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  
  // Bitişik Nizam
  const handleInputChangeQ1 = (e) => {
    setQ1(e.target.value);

    if (e.target.value === "Evet") {
      Modal.error({
        title: parse('Bitişik nizam yapılara deprem yalıtımı uygulanamamaktadır. Daha fazla bilgi için <a href="http://www.tis.com.tr">www.tis.com.tr</a> adresini ziyaret ediniz'),
        okText: "Kapat",
        okType: "danger",
      });
    }
  };

  // Yapı Türü
  const handleInputChangeQ2 = (e) => {
    setQ2(e.target.value);

    if (e.target.value === "Eski") {
      Modal.error({
        title: parse('Deprem yalıtımı ile güçlendirme projeleri için daha fazla bilgi için <a href="http://www.tis.com.tr">www.tis.com.tr</a> adresini ziyaret ediniz'),
        okText: "Kapat",
        okType: "danger",
      });
    }
  };

  // Kat Sayısı
  const handleInputChangeQ3 = (value) => {
    setQ3(value);

    if (value === "15+") {
      Modal.error({
        title: parse('15 kat üzeri yapılar için deprem yalıtımı uygulamasının tek başına yapılabilmesi genellikle mümkün olmamaktadır. Daha fazla bilgi için <a href="http://www.tis.com.tr">www.tis.com.tr</a> adresini ziyaret ediniz'),
        okText: "Kapat",
        okType: "danger",
      });
    }
  };

  // TBDY
  const handleInputChangeQ4 = (value) => {
    setQ4(value);

    if (value === "ZF") {
      Modal.error({
        title: parse('ZF sınıfı zeminlerde bulunan yapılar için deprem yalıtımı uygulamasının yapılabilmesi genellikle mümkün olmamaktadır. Daha fazla bilgi için <a href="http://www.tis.com.tr">www.tis.com.tr</a> adresini ziyaret ediniz'),
        okText: "Kapat",
        okType: "danger",
      });
    }


  };

  const handleInputChangeSehir = (value) => {
    setSelectedCity(value);
  };


  useEffect(() => {
    let timerId;

    const fetchBaseFiyat = async () => {
      try {
        const response = await fetch(`${REACT_APP_SUPABASE_URL}/rest/v1/fiyatlar2?il=eq.${selectedCity[0]}&ilce=eq.${selectedCity[1]}&kat=eq.${q3}&tbdy=eq.${q4}`, {
          method: "GET",
          headers: {
            apikey: REACT_APP_SUPABASE_KEY,
          }
        });
        const data = await response.json();
        if (data[0].fiyat > 5) {
          setBaseFiyat(data[0].fiyat);
          setDepremSeviye(data[0].deprem_seviyesi);
          // console.log("Base Fiyat", baseFiyat);
        } else {
          // console.log("Error fetching data:", htmlContent);
        }
        
      } catch (error) {
        // console.error("Error loading city data:", error);
      }
    };

    fetchBaseFiyat();
    
    return () => clearTimeout(timerId);
  }, [selectedCity[0], selectedCity[1], q3, q4]);

  // Toplam İnşaat Alanı
  const handleInputChangeQ5 = (e) => {
    setQ5(parseInt(e.target.value));

  };

  // Toplam Oturum Alanı
  const handleInputChangeQ6 = (e) => {
    setQ6(parseInt(e.target.value));
  };

  const handleInputChangeCompanyName = (e) => {
    setCompanyName(e.target.value);
  };


  const handleInputChangeUserName = (e) => {
    setUserName(e.target.value);
  };

  const handleInputChangePhone = (e) => {
    setPhone(e.target.value);
  };

  const handleInputChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };

  const handleModalOpen = (e) => {
    e.preventDefault();
    setModalVisible(true);
  };


  const handleOk = () => {
    setChecked(true);
    setModalVisible(false);
  };

  const handleCancel = () => {
    setChecked(false);
    setModalVisible(false);
  };




  const handleFiyatHesaplaClick = () => {

    // create async function
    const validate = async () => {
      try {
        // Also check q1 == 'Yeni', otherwise throw error
        if (q1 === "Evet") {
          throw new Error("Bitişik nizam yapılara deprem yalıtımı uygulanamamaktadır.");
        }
        if (q2 === "Eski") {
          throw new Error("Deprem yalıtımı ile güçlendirme projeleri için daha fazla bilgi için www.tis.com.tr adresini ziyaret ediniz");
        }
        if (q4 === "ZF") {
          throw new Error("ZF sınıfı zeminlerde bulunan yapılar için deprem yalıtımı uygulamasının yapılabilmesi genellikle mümkün olmamaktadır. Daha fazla bilgi için www.tis.com.tr adresini ziyaret ediniz");
        }
        if (checked === false) {
          throw new Error("Aydınlatma Metni'ni kabul etmeniz gerekmektedir.");
        }
        // Also check for all inputs are filled, including q1, q2, q3, q4, q5, q6, companyName, userName, phone, email
        if (selectedCity.length === 0) {
          throw new Error("Lütfen il ve ilçe seçiniz.");
        }
        if (q1 === null) {
          throw new Error("Lütfen bina nizam türü seçiniz.");
        }
        if (q2 === null) {
          throw new Error("Lütfen yapı türü seçiniz.");
        }
        if (q3 === null) {
          throw new Error("Lütfen kat sayısı seçiniz.");
        }
        if (q4 === null) {
          throw new Error("Lütfen TBDY zemin sınıfı seçiniz.");
        }
        if (q5 === null || isNaN(q5)) {
          throw new Error("Lütfen toplam inşaat alanını giriniz.");
        }
        if (q6 === null || isNaN(q6)) {
          throw new Error("Lütfen toplam oturum alanını giriniz.");
        }
        if (q5 <= 0 ) {
          throw new Error("Toplam inşaat alanı 0'dan büyük olmalıdır.");
        }
        if (q6 <= 0) {
          throw new Error("Toplam oturum alanı 0'dan büyük olmalıdır.");
        }
        if (q6 > q5) {
          throw new Error("Toplam inşaat alanı toplam oturum alanından küçük olamaz.");
        }
        if (companyName === "") {
          throw new Error("Lütfen firma adını giriniz.");
        }
        if (userName === "") {
          throw new Error("Lütfen ad soyad bilgisini giriniz.");
        }
        if (phone.length != 10) {
          throw new Error("Lütfen telefon numarası kontrol ediniz.");
        }
        // check email format, should be something@something
        if (email === "") {
          throw new Error("Lütfen email adresini giriniz.");
        }
        if (email.indexOf("@") === -1 || email.indexOf(".") === -1) {
          throw new Error("Lütfen email adresini kontrol ediniz.");
        }
        if (baseFiyat < 5) {
          throw new Error("Sistemsel Hata. Tekrar Deneyiniz.");
        }
        if (tcmbEuro < 5) {
          throw new Error("Sistemsel Hata. Tekrar Deneyiniz.");
        }


        

        return new Promise((resolve) => {


          setTotalStatikMaliyet(totalStatikMaliyetRaw);
          setTotalIzolator(totalIzolatorRaw);
          setTotalIzolatorMaliyet(totalIzolatorMaliyetRaw);
          setToplamBedelEuro1(toplamBedelEuro1Raw);
          setToplamBedelEuro2(toplamBedelEuro2Raw);
          setToplamBedelEuro3(toplamBedelEuro3Raw);
          setProjeSuresi(projeSuresiRaw);
          setIzolatorUretimSuresi(izolatorUretimSuresiRaw);
          // console.log("Kullanılan Kur", tcmbEuro);
          // console.log("İl:", selectedCity[0]);
          // console.log("İlçe:", selectedCity[1]);
          // console.log("Base Fiyat:", baseFiyat);
          // console.log("Deprem Seviye:", depremSeviye);
          // console.log("Kat Sayısı", q3);
          // console.log("TBDY", q4);
          // console.log("Toplam İnşaat Alanı", q5);
          // console.log("Toplam Oturum Alanı", q6);
          // console.log("Total İzolatör:", totalIzolatorRaw);
          // console.log("Total İzolatör Maliyet:", totalIzolatorMaliyetRaw);
          
          // console.log("Total Statik Maliyet:", totalStatikMaliyetRaw);
          // console.log("Euro Bedel:", toplamBedelEuro3Raw);
          // console.log("Proje Süresi", projeSuresiRaw); 
          // console.log("İzolatör Üretim Süresi", izolatorUretimSuresiRaw);

          resolve(true);
        });
      } catch (errorInfo) {
        // console.log("Failed:", errorInfo);
        Modal.error({
          title: "Lütfen bilgilerini kontrol ediniz.",
          content: parse(errorInfo.message),
          okText: "Kapat",
          okType: "danger",
        });
        return false;
      }
    };

    validate().then(isValid => {
      // console.log("isValid", isValid);
      if (isValid) {
        // console.log("Button clicked");
        setIsButtonClicked(true);  // Set the flag indicating the button has been clicked
      }
    });
  };

  useEffect(() => {
    if (ToplamBedelEuro3 !== 0 && izolatorUretimSuresi.min !== 0 && isButtonClicked) {
      createPdf();
      setIsButtonClicked(false);
      // fetch(`https://api.telegram.org/bot6207432754:AAHsXexDVX2nj4mKZRUXBkkZNh_Aadp-SAM/sendMessage?chat_id=486321294&text=${messagetext}`)

      let headersList = {
        "apikey": REACT_APP_SUPABASE_KEY,
        "Content-Type": "application/json"
      }

      let bodyContent = JSON.stringify({
        "firma_adi": companyName,
        "ad_soyad": userName,
        "telefon": "+90" + phone,
        "email": email,
        "il": selectedCity[0],
        "ilce": selectedCity[1],
        "kat_sayisi": q3,
        "tbdy": q4,
        "insaat_alani": q5,
        "oturum_alani": q6,
        "izolator_sayisi": totalIzolator,
        "izolator_maliyet": totalIzolatorMaliyet,
        "statik_maliyet": totalStatikMaliyet,
        "toplam_bedel": ToplamBedelEuro3.toLocaleString('de-EN') + " - " + ToplamBedelEuro2.toLocaleString('de-EN') + " €",
        "proje_suresi": projeSuresi.min + " - " + projeSuresi.max + " Hafta",
        "izolator_uretim_suresi": izolatorUretimSuresi.min + " - " + izolatorUretimSuresi.max + " Hafta",
        "toplam_sure": (projeSuresi.min + izolatorUretimSuresi.min + 1) + " - " + (projeSuresi.max + izolatorUretimSuresi.max + 2) + " Hafta",
        "kullanilan_kur": tcmbEuro,
        "tek_izolator_fiyat": baseFiyat,
        "deprem_seviye": depremSeviye,
      });

      fetch(`${REACT_APP_SUPABASE_URL}/rest/v1/kullanici_veri`, {
        method: "POST",
        body: bodyContent,
        headers: headersList
      });

    }
  }, [ToplamBedelEuro3, izolatorUretimSuresi.min, isButtonClicked]);

  function calculateProjeSuresi(q5) {
    let minDuration = 6;
    let maxDuration = 10;

    if (q5 > 10000) {
      const additionalWeeks = Math.ceil(((q5 - 10000) / 5000));
      minDuration += additionalWeeks;
      maxDuration += additionalWeeks;
    }
    return { min: minDuration, max: maxDuration };
  }

  function calculateIzolatorUretimSuresi(totalIzolatorRaw) {
    let minDuration = 4;
    let maxDuration = 5;

    if (totalIzolatorRaw > 100) {
      const additionalWeeks = Math.ceil(((totalIzolatorRaw - 100) / 50));
      minDuration += additionalWeeks;
      maxDuration += additionalWeeks;
    }

    return { min: minDuration, max: maxDuration };
  }



  const [form] = Form.useForm();


  function toDataURL(url) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = reject;
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }




  async function createPdf() {
    const logoDataUrl = await toDataURL(companyLogo);

    // const facebookLogoUrl = await toDataURL(facebookLogo);
    // const instagramLogoUrl = await toDataURL(instagramLogo);
    // const linkedinLogoUrl = await toDataURL(linkedinLogo);
    // const youtubeLogoUrl = await toDataURL(youtubeLogo);

    const html = `
    <div>
    <p>Sayın <b><span id="input_name">${userName}</span></b>,</p>
    <b><span id="input_company">${companyName}</span></b>
    <p>Gönderdiğiniz proje bilgileri ışığında <span id="input_city">${selectedCity[0]}</span> ilinin <span
            id="input_province">${selectedCity[1]}</span> ilçesinde bulunan projeniz için ön değerlendirmenizi yaptık. Fiyat
        detaylarına geçmeden önce, bu proje üzerindeki mimari ve statik ağırlıklı kritik bazı yorumlarımızı ve daha da
        önemlisi bu uygulamanın süreçlerini sizinle paylaşmak istiyoruz. İzolatörlü binalarda uygulanması şart olan ve
        birtakım hususlar ve içlerinden seçim yapılması gereken durumlar var, tüm bu bilgileri aşağıda listeliyoruz.
        Aşağıda sunduğumuz bilgiler, projenin statik projelendirmesi henüz yapılmadığı için birtakım varsayımlar
        içermektedir. Lütfen bunu göz önünde bulundurunuz.</p>
    <ul>
        <li>Yapının (varsa) mimari ve statik projelerinin tümü deprem yalıtımına uygun olarak yeniden hazırlanmalıdır.
            Var olan projeler olduğu gibi kullanılamayacaktır.</li>
        <li>Yapının zemin sınıfı verdiğiniz bilgiye uygun olarak <b><span id="input_tbdy">${q4}</span></b> olarak değerlendirilmiştir. Projenin zemin etüt
            raporunun tarafımıza iletilmesinin ardından ya da TBDY2018’e göre yeniden yapılacak zemin etüdü neticesinde
            <b><span id="input_tbdy2">${q4}</span></b> harici bir zemin sınıfı çıkması durumunda değişiklikler söz konusu olabilir. Zeminin daha zayıf olması
            halinde deplasman talebi ve birim fiyatlar artacaktır; daha kuvvetli olması halinde ise azalacaktır.</li>
        <li>Statik projelendirme henüz yapılmadığı için kat ağırlıkları yaklaşık olarak alınmıştır. Bundan dolayı,
            izolatör sayısının ve fiyatların yaklaşık olarak düşünülmesi gerekmektedir. Kesin izolatör sayıları ve tüm
            statik detaylar statik projelendirme sonrasında belirlenecektir.</li>
    </ul>
    <strong><em><u>İzolatör uygulaması ile ilgili hususlar:</em></strong></u>
    <ul>
        <li>
            <u>İzolatör konumlarının belirlenmesi.</u> Ön değerlendirme aşamasında yapının oturum alanına göre izolatör
            sayısı yaklaşık olarak belirlenmiştir. İkinci aşamada, tarafımıza ileteceğiniz mimari projeler
            değerlendirilecek ve mimariye olabildiğince uyacak şekilde her kolona bir adet izolatör gelecek şekilde
            genel bir çalışma daha yapılacaktır. Statik proje aşamasına geçerken oluşacak nihai mimari ile birlikte
            adetlerde yeniden güncelleme yapılabilecektir.
        </li>
    </ul>
    <ul>
        <li>
            <u>İzolatör uygulanacak katta ve altında bulunan tüm kolonların ve kesitlerin büyütülmesi.</u> Şu aşamada
            izolatör seviyesinin altında bulunan tüm kolonlar için yaklaşık boyutların 100x100 cm ile 150x150 cm
            arasında kare olarak düşünülmesi uygun olacaktır. Bu boyutlar, izolatörlerin boyutları (çapı ve bağlantı
            elemanları) ve yapısal analizler sonucu belirlenmektedir. \n
        </li>
    </ul>
    <em>Bu noktada, üst yapı kolonlarının aynı boyutlarla devam etmeyeceğini, kolonların statik hesaplar neticesinde
        küçüleceğini ve/veya bazılarının dikdörtgene dönüştürülebileceğini söylemek isteriz.</em>
    <ul>
        <li>
            <u>İzolatör üstü taşıyıcı sistem.</u> İzolatör seviyesinin üstündeki yapıda mümkün olduğunca perdesiz
            (kolon-kiriş çerçeve sistem) ve kare kolonlar kullanılması gerekmektedir. Taşıyıcı sistemin yapısı ve
            kolon-kiriş-perde ebatları statik hesaplar ile kesinleşecek olmakla birlikte üst yapıda kare ya da kareye
            yakın ebatta kolonlar kullanılması gerektiğini belirtmek isteriz.
        </li>
    </ul>
    <ul>
        <li>
            <u>Döşeme tipi.</u> Yapının tümünde kirişli döşeme kullanılması önerilmektedir. Mimarinin buna göre
            değerlendirilmesi gerekmektedir. Statik proje aşamasında döşeme tipinde değişiklik yapılabileceği de göz
            önüne alınmalıdır.
        </li>
    </ul>
    <ul>
        <li>
            <u>Dilatasyon.</u> (Varsa) Mimaride bloklar arasındaki dilatasyonların kaldırılması gerekmektedir. Bloklar
            birlikte çalışacak şekilde düşünülmeli ve planlanmalıdır.
        </li>
    </ul>
    <ul>
        <li>
            <u>İzolatör uygulama seviyesinin/katının belirlenmesi.</u> İzolatör yerleşimine uygun boş (ya da otopark,
            depo alanı, vb) bir bodrum kat bulunduğu varsayılarak izolatörlerin bu bölüme koyulabileceği
            öngörülmektedir. Kesin yerleşim yeri mimari projelerin tarafımıza iletilmesinin ardından belirlenecektir.
        </li>
    </ul>
    <ul>
        <li>
            <u>Sismik boşluklar.</u> İzolatörlü bir yapının, izolatör uygulanan bölgesine bağlı olarak, etrafında
            harekete engel olmayacak şekilde sismik boşlukların bırakılması gerekmektedir. Bu projedeki sismik boşluk
            detayları mimari aşamada belirlenecektir ancak ilk aşamada yapının izolatör uygulanan ve deprem anında
            hareket edecek kısmının etrafında en az 50 cm boşluk bırakılacak şekilde planlanması gerekmektedir.
        </li>
    </ul>
    <ul>
        <li>
            <u>(Sadece) izolatörlerin yerleştirileceği katın üzerindeki döşeme kalınlığının minimum 30-35 cm’ye
                çıkarılması ya da çok rijit bir kiriş sistemi uygulanması.</u> Bu, izolatörlerin daha doğru bir şekilde
            çalışabilmesi için gereklidir.
        </li>
    </ul>
    <ul>
        <li>
            <u>Elektrik ve mekanik tesisatı, doğalgaz bağlantıları, pis su ve diğer borulamaların izolatör seviyesinde
                her yatay yöne minimum ±50 cm deplasman yapacak şekilde detaylandırılması gerekmektedir.</u>
        </li>
    </ul>
    <em>Not: Yukarıda belirtilmiş olan deplasman, ebat ve detaylar yaklaşıktır. Ön değerlendirme aşamasında nihai
            izolatör deplasmanları ve parametreleri belirlenemediği için kesin proje aşamasında netleşecektir.</em>
    <strong><em><u>Projelendirme, danışmanlık ve gözetmenlik ile ilgili hususlar:</em></strong></u>
    <p>İzolatör uygulanacak binalar 2018 Deprem Yönetmeliği’ne göre özel yapı sınıfına girmektedir ve bu durum projelendirme aşamasında takip edilmesi ve uygulanması gereken süreçler getirmektedir. Süreç ile ilgili birkaç bilgiyi paylaşmak istiyorum:</p>
    <ul>
      <li>
          Özel yapı sınıflarının birinde yer alan izolatörlü yapılar, Çevre ve Şehircilik Bakanlığı’nın (ÇŞB) uygulamaya koyduğu Tasarım Gözetmenliği Uygulama Alanları’nın (TGUA) bazılarına tabi olmaktadır. Bu alanlar özetle, deprem tehlike analizi (TGUA-1) ve deprem yalıtımı (TGUA-5) konularıdır. ÇŞB’nin mevcut gözetmen havuzundan iki alan için de birer gözetmen seçilerek ilgili çalışmalar gözetmenlikten geçirilecektir. Bu uzman gözetmenlerin proje boyutuna göre bir ücretleri mevcuttur. Konu ile ilgili ayrıntılı bilgileri aşağıdaki linkten inceleyebilirsiniz. <a href="https://meslekihizmetler.csb.gov.tr/turkiye-bina-deprem-yonetmeligi-tasarim-gozetimi-ve-kontrolu-hizmetleri-uygulamasi">Bu Linkteki</a> ilk maddede tebliğin içerisinde gerekli bilgiler mevcuttur. Tasarım gözetmenlerini işveren olarak siz seçebiliyor olacaksınız ve kanun gereği sözleşmeyi direkt işveren olarak siz yapıyor olacaksınız.
      </li>
    </ul>
    <ul>
      <li>
          Özel yapı sınıfına giren yapılar, AFAD’ın deprem haritasına tabi olarak projelendirilmesinin yanı sıra proje alanı için ayrıca bir Sahaya Özgü Deprem Tehlike Analizi yapılmakta, bu sonuçlar harita sonuçlarıyla birlikte kullanılmaktadır. Bu çalışma da deprem tehlikesi belirlenmesi konusunda uzman bir kişi ile yapılmaktadır.
      </li>
    </ul>
    <ul>
      <li>
          Tasarım gözetmenliklerinin yanı sıra, deprem yalıtımlı binaların projelendirmesini de ayrıca uzmanlık ve tecrübe gerektiren bir disiplin olarak kabul etmekteyiz. Bu aşamada ancak sağlıklı, güvenli ve yeterli bir çalışma, tasarım gözetmenlerinden de geçer not alabilmektedir. Örneğin, piyasada kullanılan analiz programlarından SAP2000, ETABS ya da Perform3D gibi yazılımlar izolatörlü binaların modellemesini ve deprem kayıtları ile kontrolünü yapabilmektedir (piyasada yaygın kullanılan paket programlar ile bu hesaplar yapılamamaktadır). Özetle, bu bilgiler ışığında bu özel projelerin yeterliliği referanslarla kanıtlanmış projeciler tarafından yapılmasını uygun görmekteyiz. Statik proje işleri konusunda süreci kendimiz de üstlenebilmekle birlikte birkaç farklı alternatif firmayı direkt sizlere de önerebiliriz.
      </li>
    </ul>
    <p>Yukarıda paylaştığımız tüm bilgiler ve yorumlarımız ışığında, projenizde toplam <b><span id="izolator">${totalIzolator}</span> adet </b> izolatör kullanımı öngördük. Projeniz için yaklaşık bütçeyi <b><span id="euro4">${ToplamBedelEuro3.toLocaleString('de-EN')}</span> EUR + KDV </b> ile <b><span id="euro3">${ToplamBedelEuro2.toLocaleString('de-EN')}</span> EUR + KDV </b> arasında öngörmekteyiz. Ancak, mertebelerin benzer olmasını öngörmekle birlikte izolatör işlerinde daha kesin bir fiyatlandırmanın, kesin izolatör sayısı ve boyutları statik projelendirme aşamasından sonra belli olunca yapılacağını belirtme gereği duyuyoruz. Söz konusu bütçeye deprem izolatörü işleri (yalıtım sisteminin tasarım, mühendislik hizmetleri, üretimi, üretim testleri, prototip testleri, şantiye sahasına nakliyesi, şantiye montajı, garanti süresince servis hizmeti dahil anahtar teslim) ve statik proje hizmetleri (sahaya özel deprem tehlike analizlerinin yapılması, tüm statik proje işlerinin yapılması, mimari ve mekanik projelerde gerektiğinde danışmanlık hizmetlerinin verilmesi, TGUA-1 ve TGUA-5 masrafları dahildir). 
Tüm uygulama aşamalarındaki ücretlerin yanı sıra yaklaşık olarak süreç takvimini de aşağıda paylaşıyoruz. Takvim, TBDY2018 yönetmeliğine uygun olarak hazırlanmış zemin etüdünün tamamlanmasının ardından başlayacaktır.</p>
<table>
<tr>
  <th>Uygulama Konusu</th>
  <th>Süreç</th>
  <th>Toplam Süre</th>
</tr>
<tr>
  <td>
  • Sahaya özgü deprem tehlike analizlerinin yapılması <br>
  • TGUA-1 onayı <br>
  • Mimarinin kesinleştirilmesi</li> <br>
  • Statik proje hesapları (TGUA-1 onayı sonrası) <br>
  • TGUA-5’in statik proje onayı <br>
  • Deprem izolatörü hesaplarının yapılması <br>
  • TGUA-5’in deprem izolatörü onayı <br>
  </td>
  <td><span id="projeSure1">${projeSuresi.min}</span> hafta ile <span id="projeSure2">${projeSuresi.max}</span> hafta arasında</td>
  <td><span id="projeSureTotal1">${projeSuresi.min}</span> - <span id="projeSureTotal2">${projeSuresi.max}</span> hafta</td>
</tr>
<tr>
  <td>• Onayların tamamlanmasının ardından izolatörlerin malzeme planlama ve siparişi, üretim ve testleri (*)</td>
  <td><span id="izolatorSure1">${izolatorUretimSuresi.min}</span> hafta ile <span id="izolatorSure2">${izolatorUretimSuresi.max}</span> hafta arasında</td>
  <td><span id="izolatorSureTotal1">${izolatorUretimSuresi.min + projeSuresi.min}</span> - <span id="izolatorSureTotal2">${izolatorUretimSuresi.max + projeSuresi.max}</span> hafta</td>
</tr>
<tr>
  <td>• İzolatörlerin şantiyeye sevkiyatı ve montajı</td>
  <td>1 hafta ile 2 hafta arasında</td>
  <td><b><span id="montajTotalSure">${izolatorUretimSuresi.min + projeSuresi.min + 1}</span> - <span id="MontajTotalSure2">${izolatorUretimSuresi.max + projeSuresi.max + 2}</span> hafta</b></td>
</tr>
</table>
<em>(*) Takvimi verilen bu süreç içerisinde prototip testleri de gerçekleştirilecek, bu testler ve raporlarının alınması üretim ile paralel olarak gidecektir.</em>
<p>Bu programda gördüğünüz sürelerden ötesi, deprem yalıtımlı bir proje gerçekleştirmenin; yüklenici, statik proje müellifi, izolatör üreticisi, tasarım gözetmenleri ve diğer proje müelliflerini içeren çok boyutlu bir süreç içerdiğini belirtmek isteriz. Böyle bir projenin sağlıklı, olabildiğince ekonomik ve hızlı bir şekilde ilerlemesi için bu paydaşların büyük uyum içerisinde çalışması gerektiğini belirtmek isteriz.</p>
<p>Bu cevabımızda, binanıza ve projelerinize izolatör uygulaması ile ilgili maliyet ve süreç takvimini şeffaf ve olabildiğince ayrıntılı vermeye çalıştık. 3 iş günü içinde projeniz ile ilgili daha detaylı bilgi alışverişi yapabilmek adına firmamız tarafından size ulaşılacaktır. </p>
<div style="text-align: right;">
Sağlıklı günler ve iyi çalışmalar dileriz.
<p>Saygılarımızla,</p>
<b>TİS Teknolojik İzolatör Sistemleri</b>
</div>
`;

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 40, 40, 60],
      footer: {
        text: "TİS Teknolojik İzolatör Sistemleri |  tis.com.tr  | +90 312 284 09 40 | Emirgazi Mahallesi No:35/M Kahramankazan / ANKARA / Türkiye",
        alignment: 'left',
        fontSize: 8,
        alpha: 0.5,
        margin: [20, 20, 20, 0],
        color: "grey"
      },

      background: {
        image: logoDataUrl,
        width: 500,
        height: 500,
        alignment: 'center',
        margin: [20, 200, 20, 0],
        opacity: 0.2
      },
      content: [
        htmlToPdfmake(html)
      ],
      defaultStyle: {
        font: "TimesNewRoman",
        fontSize: 11,
        lineHeight: 1.16,
        alignment: 'justify'
      },
      style: {
        icon: {
          font: 'Fontello'
        }
      },
    };

    pdfMake.createPdf(docDefinition).download('tis_izolator_fiyat_teklifi.pdf');
  }


  return (
    <div className="app">
      <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
        <Col xs={22} sm={16} md={12} lg={10}>
          <Card className="app-card" title={<Typography.Title level={2} style={{ textAlign: 'center' }}>Sismik İzolatör Teklif Uygulaması</Typography.Title>} bordered={false}>
            <Form layout="vertical" form={form}>

              <Form.Item label="Binanız Bitişik Nizam mı?">
                <Row justify="center">
                  <Radio.Group onChange={handleInputChangeQ1} value={q1}>
                    <Radio.Button value="Evet">Evet</Radio.Button>
                    <Radio.Button value="Hayır">Hayır</Radio.Button>
                  </Radio.Group>
                </Row>
              </Form.Item>

              <Form.Item label="Yapı Türü">
                <Row justify="center">
                  <Radio.Group onChange={handleInputChangeQ2} value={q2}>
                    <Radio.Button value="Yeni">Yeni Yapı, Yeni İnşaat</Radio.Button>
                    <Radio.Button value="Eski">Var Olan Yapı</Radio.Button>
                  </Radio.Group>
                </Row>
              </Form.Item>

              <Form.Item label="Kat Sayısı">
                <Row justify="center">
                  <Col xs={24} sm={16} md={12} lg={8}>
                    <Select
                      name="q3"
                      id="q3"
                      value={q3}
                      onChange={handleInputChangeQ3}
                      allowClear
                      optionFilterProp="children"
                    >
                      {[...Array(14).keys()].map((num) => (
                        <Option key={num + 2} value={num + 2}>
                          {num + 2}
                        </Option>
                      ))}
                      <Option key="15+" value="15+">
                        15+
                      </Option>
                    </Select>
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="TBDY 2018 şartlarına göre yapının zemin sınıfı nedir?">
                <Row justify="center">
                  <Col xs={24} sm={16} md={12} lg={8}>
                    <Select
                      name="q4"
                      id="q4"
                      value={q4}
                      onChange={handleInputChangeQ4}
                      searchValue=""
                      optionFilterProp="children"
                    >
                      <Option key="ZA" value="ZA">
                        ZA
                      </Option>
                      <Option key="ZB" value="ZB">
                        ZB
                      </Option>
                      <Option key="ZC" value="ZC">
                        ZC
                      </Option>
                      <Option key="ZD" value="ZD">
                        ZD
                      </Option>
                      <Option key="ZE" value="ZE">
                        ZE
                      </Option>
                      <Option key="ZF" value="ZF">
                        ZF
                      </Option>
                    </Select>
                  </Col>
                </Row>
              </Form.Item>


              <Form.Item label="Binanın Bulunduğu İl ve İlçe">
                <Row justify="center">
                  <Col xs={24} sm={18} md={18} lg={18}>
                    <Cascader
                      options={cascaderOptions}
                      placeholder="İl ve İlçe Seçiniz"
                      onChange={handleInputChangeSehir}
                      showSearch
                      allowClear
                    />

                  </Col>
                </Row>
              </Form.Item>



              <Form.Item label="Yapının Toplam İnşaat Alanı (m²)" style={{ padding: 0 }}>
                <Row justify="center">
                  <Col xs={24} sm={16} md={12} lg={8}>
                    <Input
                      type="number"
                      name="q5"
                      id="q5"
                      min="0"
                      max="10000000"
                      value={q5}
                      onChange={handleInputChangeQ5}
                    />
                  </Col>
                </Row>
              </Form.Item>


              <Form.Item label="Yapının Toplam Oturum Alanı (m²)">
                <Row justify="center">
                  <Col xs={24} sm={16} md={12} lg={8}>
                    <Input
                      type="number"
                      name="q6"
                      id="q6"
                      min="0"
                      max="1000000"
                      value={q6}
                      onChange={handleInputChangeQ6}
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="Firma Adı" name="companyName"
                rules={[{ required: true, message: 'Lütfen Firma Adı Giriniz', whitespace: true }]}>
                <Row justify="center">
                  <Col xs={24} sm={18} md={18} lg={18}>
                    <Input
                      name="nickname"
                      value={companyName}
                      onChange={handleInputChangeCompanyName}
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="Ad Soyad" name="userName"
                rules={[{ required: true, message: 'Lütfen Adınızı Giriniz', whitespace: true }]}>
                <Row justify="center">
                  <Col xs={24} sm={18} md={18} lg={18}>
                    <Input
                      name="nickname"
                      value={userName}
                      onChange={handleInputChangeUserName}
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="Eposta" name="email"
                rules={[
                  {
                    type: 'email',
                    message: 'Eposta formatı hatalıdır.',
                  },
                  {
                    required: true,
                    message: 'Lütfen Eposta Adresinizi Giriniz',
                  },
                ]}>
                <Row justify="center">
                  <Col xs={24} sm={18} md={18} lg={18}>
                    <Input
                      name="email"
                      value={email}
                      onChange={handleInputChangeEmail}
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item label="Telefon" name="phone" id="phone"
                rules={[{ required: true, message: 'Lütfen Telefon Numarınız Giriniz' },
                { len: 10, message: 'Telefon formatı hatalıdır.' }]}>
                <Row justify="center">
                  <Col xs={24} sm={18} md={18} lg={16}>
                    <Input
                      name="phone"
                      value={phone}
                      onChange={handleInputChangePhone}
                      addonBefore={"+90"}
                      style={{ marginLeft: 0 }}
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item>
                <Row justify="center">
                  <Col xs={24} sm={24} md={16} lg={16}>
                    <center><Checkbox checked={checked} onChange={handleCheckboxChange}>
                      <a href="#" onClick={handleModalOpen}>Aydınlatma Metni</a>'ni okudum ve kabul ediyorum.
                    </Checkbox></center>
                    <br></br>
                    <Modal
                      visible={modalVisible}
                      onCancel={handleCancel}
                      onOk={handleOk}
                      okText="Kabul Ediyorum"
                      cancelText="Kabul Etmiyorum">
                      <div style={{ maxHeight: '400px', overflowY: 'scroll' }}>
                        <p>TİS TEKNOLOJİK İZOLATÖR SİSTEMLERİ A.Ş.
                          <br />
                          KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİNE
                          DAİR AYDINLATMA METNİ VE GİZLİLİK POLİTİKASI
                          <br />
                          İşbu Gizlilik Politikası ve Aydınlatma Metni’nde, kişisel verilerinizin, 6698 sayılı Kişisel
                          Verilerin Korunması Kanunu (“Kanun”) ve ilgili mevzuata uygun olarak, veri sorumlusu
                          Tis Teknolojik İzolatör Sistemleri A.Ş. (“Şirket”) nezdinde işlenmesine ilişkin esaslar aşağıda belirtilmiştir.
                          Kişisel veri nedir?
                          6698 sayılı Kişisel Verilerin Korunması Kanununun 3. maddesi uyarınca kişisel veri, kimliği
                          belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgiyi ifade eder. Tarafımız, 6698 sayılı
                          Kişisel  Verilerin  Korunması  Kanunu  uyarınca  veri  sorumlusu  sıfatıyla  kişisel verilerinizi
                          kanuna uygun olarak kaydedecek, saklayacak, güncelleyecek, işleyecek ve mevzuatın izin
                          verdiği durumlarda üçüncü kişilere açıklayabilecek ve aktarabilecektir. Kişisel veri yönetimi
                          süreçlerimize ilişkin açıklamalarımız işbu metinde sunulmaktadır.
                          1. Veri Sorumlusu ve Temsilcisi
                          Kişisel verileriniz mevcut teknolojinin gerekleri uyarınca veri sorumlusu Tis Teknolojik İzolatör sistemleri
                          A.Ş.  tarafından aşağıda belirtilen usullerde işlenmektedir.
                          2. Kişisel Verilerin İşlenmesi Hakkında Bilgilendirme Metni
                          İşbu “Bilgilendirme Metni”, Şirket olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu
                          (“KVKK”)  uyarınca,  Veri  Sorumlusu  sıfatıyla,  KVKK’da yer  alan  “Veri  Sorumlusunun
                          Aydınlatma  Yükümlülüğü”  başlıklı  10.  ve  “İlgili  Kişinin  Hakları”  başlıklı  11.  maddesi
                          çerçevesinde; hangi amaçla kişisel verilerinizin işleneceği, işlenen kişisel verilerinizin kimlere
                          ve hangi amaçla aktarılabileceği, kişisel verilerinizin toplanmasının yöntemi ve hukuki sebebi
                          ve KVKK’nın 11. maddesinde sayılan diğer haklarınızla ilgili olarak size bilgi vermek ve
                          aşağıdaki hususlarda onayınızı almak amacıyla sunulmaktadır.
                          Bize sağladığınız kişisel verilerin gizliliğini ve güvenliğini korumaya önem veriyoruz. Bu
                          doğrultuda, kişisel verilerinizi yetkisiz erişim, zarar, kayıp veya ifşaya karşı korumak için
                          gerekli teknik ve idari güvenlik önlemlerini almaktayız.
                          3. Kişisel Verilerin Toplanması, İşlenmesi ve İşleme Amaçları
                          Şirket olarak, Veri Sorumlusu sıfatıyla, ilgili mevzuattan kaynaklanan yasal yükümlülüklerimiz
                          çerçevesinde  ve  müşterilerimizin  hizmetlerimizden  faydalanabilmesi  amacıyla,  kişisel
                          verileriniz Şirket tarafından verilen hizmet, ürün ya da ticari faaliyete bağlı olarak değişkenlik
                          gösterebilmekle; otomatik ya da otomatik olmayan yöntemlerle, ofisler, kamera kayıtları,
                          internet sitesi, sosyal medya hesapları ve benzeri vasıtalarla sözlü, yazılı ya da elektronik olarak
                          toplanabilecektir. Ayrıca Şirketimiz faaliyetleri çerçevesinde tedarikçiler, kamu Şirketları ve
                          diğer akdi muhataplarımızın verileri de aynı yöntemlerle ve hizmetlerimizde zaruri olan iş
                          süreçlerini sağlamak amacıyla toplanabilecektir. Ayrıca ilgili tüm kanun ve yönetmelikler
                          gereğince faaliyetlerimizin yerine getirilmesi, sürdürülebilmesi, yürütülmesi, geliştirilmesi,
                          hizmet ve faaliyetlere yönelik tanıtım, kampanya ve benzeri faaliyetlerin yapılması, davet, yeni
                          uygulamaların  bildirilmesi,  tanzim  edilen  veya  edilecek  sözleşmelerin  gereğinin  yerine getirilmesi, planlama, istatistik, memnuniyet anketlerinin yapılması, güvenliğin sağlanması, e-
                          mail  ortamında,  e-postalar,  e-bülten  üyelikleri,  sosyal  medya  paylaşımları,  düzenlenen
                          etkinliklerde doldurulan basılı formlar, çalışan adaylarla yüz yüze yapılan mülakat sırasında
                          veya yazılı başvuru formu, elektronik ortamda dijital başvuru formu gönderilmesi veya e-posta,
                          kargo, ve benzeri yöntemlerle özgeçmişlerini göndermeleri halinde veya danışmanlık firmaları
                          veya telefon gibi araçlarla ve adayın ilettiği bilgilerin teyidini sağlayan kontrol ve araştırmalar
                          sebebiyle işe alım süreçlerinde toplanan kişisel verileri ile işin niteliğine göre toplanan özel
                          nitelikli kişisel verileri, iş ilişkisi içerisinde olan kişilerin hukuki ve ticari güvenliğinin idamesi,
                          hukuki ve mali işler ve benzeri ticari ve iş stratejilerinin belirlenmesi, uygulanması, insan
                          kaynakları, muhasebe politikalarının yürütülmesi, fiziksel güvenlik ve denetimin sağlanması,
                          yurt içi ve uluslar arası mevzuata uyum, kamu kuruluşlarınca veya diğer otoritelerce istenen
                          bilgi aktarımı, saklama, raporlama yükümlülüklerine uyulması, tarafınıza daha iyi ve daha
                          güvenilir hizmet verilebilmesi ve kesintisiz sürdürülebilmesi için KVK Kanunun 5 ve 6.
                          maddelerinde belirlenen şartlar ve amaçlar dahilinde işlenmektedir.
                          Şirketin  ürün  ve  hizmetlerinden  yararlandığınız  müddetçe  oluşturularak  ve  güncellenerek
                          kişisel verileriniz işlenebilecektir.
                          4. Kişisel Verilerin Muhafaza Edilme Süresi
                          Bu  kişisel  veriler;  Şirket olarak  sunduğumuz  hizmetlerden  yararlanabilmeniz  adına,  açık
                          rızanıza istinaden veya tabi olduğumuz yasal mevzuat başta olmak üzere KVKK md. 5/f.2’de
                          öngörülen  diğer  hallerde,  işbu  Kişisel  Verilerin  Korunması  Hakkında  Bilgilendirme  ile
                          belirlenen amaçlar ve kapsam dışında kullanılmamak kaydı ile gerekli tüm bilgi güvenliği
                          tedbirleri de alınarak işlenecek ve yasal saklama süresince veya işleme amacının gerekli kıldığı
                          süre boyunca saklanacak ve işleme amacının gerekli kıldığı sürenin sonunda veya veri işlenmesi
                          için rızanızın gerektiği hallerde rızanızın geri alınması halinde anonimleştirilerek Şirketimiz
                          tarafından  kullanılmaya  devam  edilecek  yada  imha  edilecektir.  Şirket,  periyodik  olarak
                          verilerin anonimleştirilmesi / imha edilmesi gerekip gerekmediğini denetlemekte ve gereken
                          verileri anonimleştirmekte / imha etmektedir.
                          5.  Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi
                          Kişisel verileriniz, her türlü sözlü, yazılı ya da elektronik ortamda, yukarıda yer verilen amaçlar
                          doğrultusunda Şirketimiz tarafından sunulan ürün ve hizmetlerin belirlenen yasal çerçevede
                          sunulabilmesi  ve  bu  kapsamda  Şirketimizin  sözleşme  ve  yasadan  doğan  mesuliyetlerini
                          eksiksiz ve doğru bir şekilde yerine getirebilmesi sebebi ile edinilir. Kişisel verileriniz, Kanun
                          tarafından öngörülen temel ilkelere, veri işleme şartlarına ve istisnalarına uygun olarak işbu
                          “Aydınlatma Metni”nde belirtilen amaçlarla da KVKK md.5 ve md.6’da belirtilen kişisel veri
                          işleme  şartları  ve  amaçları  kapsamında  yukarıdaki  maddelerde  belirtilen  amaçlarla  da
                          işlenebilmekte ve aktarılabilmektedir.
                          6. Kişisel Verilerin Aktarılması / Paylaşılması
                          Şirket, söz konusu kişisel verilerinizi sadece; müşterilerin açık rızasına istinaden veya tabi
                          olduğumuz mevzuat başta olmak üzere KVKK md. 5/f.2’de öngörülen diğer hallerde KVKK’da
                          belirtilen güvenlik ve gizlilik esasları çerçevesinde yeterli önlemler alınmak kaydıyla Şirket
                          faaliyetlerinin yürütülmesi, müşterilerimize hizmetler, fırsat ve olanaklar sunulması ve hizmet
                          kalitesinin  artırılması  amacıyla;  bağlı  Şirketlerimiz,  doğrudan/dolaylı  yurtiçi/yurtdışı
                          iştiraklerimiz, faaliyetlerimizin gereği anlaşmalı olduğumuz Şirketlar, tedarikçiler, anlaşmalı
                          satıcılar ve servisler, iş ortaklarımız, denetim Şirketleri veya yasal bir zorunluluk gereği bu verileri  talep  etmeye  yetkili  olan  kamu  Şirket  veya  kuruluşları,  bunlarla  sınırlı  olmamak  üzere
                          ilgili diğer otoriteler ile paylaşabilecektir.
                          7.  Veri İşleyene ve Veri Sorumlusuna Başvuru Yolları
                          Kişisel veri sahipleri olarak, haklarınıza ilişkin taleplerinizi, bu Aydınlatma Metni’nde aşağıda
                          düzenlenen yöntemlerle Şirketimize iletmeniz mümkündür. Bu kapsamda kişisel veri sahipleri
                          olarak;
                          a) Kişisel veri işlenip işlenmediğini öğrenme,
                          b) Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
                          c) Kişisel verilerinizin işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,
                          d) Kişisel verilerinizin yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,
                          e) Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme,
                          f) Kişisel verilerinizin silinmesini veya yok edilmesini isteme,
                          g)   Kişisel  verilerin  düzeltilmesi,  silinmesi  ya  da  yok  edilmesi  halinde  bu  işlemlerin  kişisel
                          verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
                          h)  Kişisel  verilerinizin  münhasıran  otomatik  sistemler  ile  analiz  edilmesi  nedeniyle  aleyhinize
                          bir sonucun ortaya çıkmasına itiraz etme ve
                          i)    Kişisel   verilerinizin   kanuna   aykırı   olarak   işlenmesi   sebebiyle   zarara   uğramanız   hâlinde
                          zararın giderilmesini talep etme haklarına sahipsiniz
                          Şirketimiz taleplerinizi, talebin niteliğine göre en kısa sürede ve en geç otuz gün içinde ücretsiz
                          olarak sonuçlandırır. Ancak, işlemin ayrıca bir maliyeti gerektirmesi hâlinde, ücret alınabilir.
                          Şirketimiz talebi kabul edip işleme koyabilir veya gerekçesini açıklayarak talebi yazılı usulle
                          reddedebilir.
                          Bu  kapsamda  yapacağınız  talepler  6698  Kişisel  Verileri  Koruma  Kanunu  kapsamında  yazılı
                          olmalıdır.
                          Bilgi ve başvuru taleplerinizi Başvuru Formu ’nu tıklayarak bizlere yönlendirebilirsiniz.

                          Ayrıca Tis Teknolojik İzolatör Sistemleri A.Ş. Emirgazi mahallesi no:35/M Kahramankazan/Ankara adresine  bizzat  elden  iletebilir,  noter  kanalıyla  veya  KVKK’da  belirtilen  diğer  yöntemler  ile
                          gönderebilirsiniz. Diğer yollardan gelen başvurular kabul edilmeyecektir.
                          8.   Bina  Tesis  Girişleri  ve  Bina  Tesis  İçerisinde  Kişisel  Veri  İşleme  Etkinlikleri
                          (Kamera Kaydı, Misafir İsim Soyadlarmm Kaydedilmesi)
                          Şirket tarafından güvenliğin sağlanması ve işleyişin sürdürülebilmesi amacıyla, Şirket bina ve eklentilerinde ( iç ve dış)   güvenlik   kamerasıyla   izleme   faaliyeti   yapılmakta,   misafir   giriş çıkışlarının takibe alınmaktadır. İş bu takip ile; Anayasa, KVK Kanunu ve ilgili diğer mevzuata uygun kişisel veri işlemesi yapılmaktadır. Bina girişlerinde ve zemin katlarda kamera ile izleme sistemi    vasıtasıyla    ziyaretçilerimizin    görüntü    kayıtları,    güvenilirliğini    sağlamak, hizmet kalitesini   arttırmak,   ziyaretçilerin   ve diğer kişilerin güvenliğini sağlamak gibi amaçlarla alınmakta ve bu amaçla veri işleme faaliyetinde bulunulmaktadır.
                          Dijital  ortamda  kaydedilen  ve  muhafaza  edilen  kayıtlara  yalnızca  sınırlı  sayıda  Şirket
                          çalışanının  erişimi  bulunmakta  ve  gizlilik  taahhütnamesi  ile  erişilen  verilerin  gizliliğini
                          koruyacağını beyan etmektedir.
                          9. Web Sitesi Kullanım Koşulları ve Gizlilik Politikamız
                          İşbu Gizlilik Politikası, http://www.tis.com.tr/ adresi ile ilgili hizmetleri sunarken, kişisel
                          verilerinize  ilişkin  politikamızı  içermektedir.  Bizimle  paylaşmış  olduğunuz  tüm  kişisel
                          verileriniz, Şirketimiz nezdinde yer alan veri tabanında 6698 Sayılı Kişisel Verilerin Korunması
                          Kanunu md. 12 doğrultusunda gizli olarak saklanacaktır ve ticari amaçlarla üçüncü kişilerle
                          paylaşılmayacaktır. Kişisel veri barındıran bilişim sistemlerinin yetkisiz erişimlere ve hukuka
                          aykırı  veri  işlemelere  karşı  korunmasını  sağlamak  amacıyla  her  türlü  güvenlik  tedbirleri
                          almaktadır.
                          Şirketimizin Web Sitesinde, kullanıcı kimliği ile giriş yapan ilgililer, iş başvurusu yapanlar,
                          önerilerde bulunanlar ve benzeri amaçlarla siteyi kullananlar, kişisel verileri 6698 Sayılı Kişisel
                          Verilerin Korunması Kanunu md. 5/f.1 ve md. 6/f.2 uyarınca tamamen kendi istek ve açık
                          rızaları ile paylaştıklarını, kendilerini bilgilendirmek, tanıtmak, kendilerine daha iyi hizmet
                          sunulabilmesi, yaptıkları başvuru veya şikâyetler ve diğer ilgili alanlar ile yeniliklerinden
                          haberdar edilmek amacıyla kendilerince talep edildiğini kabul ederler.
                          Kullanıcılar Web Sitesi üzerinde paylaştıkları bilgilerin doğru olmasının ve güncel bir şekilde
                          muhafaza edilmesinin 6698 Sayılı Kişisel Verilerin Korunması Kanunu anlamında kişisel
                          verileri üzerinde sahip oldukları hakları kullanabilmeleri ve ilgili diğer mevzuat açısından
                          önemli olduğunu bildiklerini ve yanlış bilgi verilmesinde doğacak sorumlulukların tamamen
                          kendilerine ait olacağını kabul ve beyan etmişlerdir.
                          10. Kanunun Yayım ve Yürürlük Tarihi
                          İş bu kanun, 07.04.2016 tarihinde yayımlanmış olup; ilgili kanunun 8. maddesi, (Kişisel
                          verilerin aktarılması), 9. maddesi, (Kişisel verilerin yurt dışına aktarılması), 11. maddesi, (İlgili
                          kişilerin hakları), 13. maddesi, (Veri sorumlusuna başvuru ), 14. maddesi, (Kurula Şikayet), 15.
                          maddesi,  (Şikayet  üzerine  veya  resen  incelemenin  usul  ve  esasları),  16.  maddesi,  (Veri
                          Sorumluları Sicili), 17. maddesi, (Suçlar) ve 18. maddesi, (Kabahatler); yayımı tarihinden altı
                          ay sonraki tarih olan 07 Ekim 2016 tarihinde yürürlüğe girmiştir. Diğer maddeleri, yayımı tarihi
                          olan 07.04.2016 tarihinde yürürlüğe girmiştir.
                        </p>
                      </div>
                    </Modal>
                    <center><Button type='primary' onClick={handleFiyatHesaplaClick}>Fiyat Teklifi Oluştur</Button></center>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );


}

export default Home;